import { Formik } from "formik";
import { Button, Col, Form, Row } from "react-bootstrap";
import {
  attPreSinAnt,
  attPregestacionalOpt,
  noAplicaOpt,
  noSiOpt,
  opt123,
  primeraVezSubsecuentaOpt,
  pesoTallaOpt,
  inicialSubsecuentaOpt,
  resultadoEdiOpt,
  resultadoBatelleOpt,
  aplicacionCedulaCanOpt,
  edasPlanTratamientOpt,
  irasPlanTratamientoOpt,
} from "./constants/options";
import Controller from "./controller/Controller";
import { Fragment, useContext, useState, useEffect } from "react";
import * as Yup from "yup";
import Post from "../../../api/Post";
import { MEDICAL_HISTORY_MX } from "../../../api/Routes";
import { authContext } from "../../../context/AuthContext";
import Put from "../../../api/Put";
import SimpleLoad from "../../../loader/SimpleLoad";
import Get from "../../../api/Get";

const fields1 = [
  {
    name: "ninoSanoRT",
    type: "select",
    label: "Consulta niño sano",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
  {
    name: "pesoParaTalla",
    type: "select",
    label: "Peso por talla",
    options: [...noAplicaOpt, ...pesoTallaOpt],
  },
  {
    name: "pruebaEDI",
    type: "select",
    label: "Consulta prueba EDI",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
  {
    name: "resultadoEDI",
    type: "select",
    label: "Resultado prueba EDI",
    options: [...noAplicaOpt, ...resultadoEdiOpt],
  },
  {
    name: "resultadoBattelle",
    type: "select",
    label: "Resultado Battelle",
    options: [...noAplicaOpt, ...resultadoBatelleOpt],
  },
  {
    name: "aplicacionCedulaCancer",
    type: "select",
    label: "Cedula Cancer",
    options: [...noAplicaOpt, ...aplicacionCedulaCanOpt],
  },
  {
    name: "confirmacionCancer",
    type: "select",
    label: "Confirmación cancer",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  {
    name: "edasRT",
    type: "select",
    label: "Consulta por enfermedad diarreica aguda",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
  {
    name: "edasPlanTratamiento",
    type: "select",
    label: "Tratamiento EDAS",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  {
    name: "recuperadoDeshidratacion",
    type: "select",
    label: "Recuperación EDAS",
    options: [...noAplicaOpt, ...edasPlanTratamientOpt],
  },
  {
    name: "numeroSobresVSOTratamiento",
    type: "number",
    label: "Sobres tratamiento",
    options: [],
  },
  {
    name: "numeroSobresVSOPromocion",
    type: "number",
    label: "Sobres promoción",
    options: [],
  },
  {
    name: "irasRT",
    type: "select",
    label: "Consulta IRAS",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
  {
    name: "irasPlanTratamiento",
    type: "select",
    label: "Tratamiento IRAS",
    options: [...noAplicaOpt, ...irasPlanTratamientoOpt],
  },

];

const fields2 = [
  {
    name: "neumoniaRT",
    type: "select",
    label: "Neumonia",
    options: [...noAplicaOpt, ...primeraVezSubsecuentaOpt],
  },
  {
    name: "gesta",
    type: "number",
    label: "Gesta a la que corresponde",
    options: [],
  },
  {
    name: "tipoNacimiento",
    type: "select",
    label: "Tipo de Nacimiento",
    options: [
      { label: "Parto", value: "Parto" },
      { label: "Cesarea", value: "Cesarea" },
    ],
  },
  {
    name: "edadGestacional",
    type: "number",
    label: "Edad Gestacional",
    options: [],
  },
  {
    name: "persoAlNacer",
    type: "number",
    label: "Peso al Nacer",
    options: [],
  },
  {
    name: "apgar",
    type: "number",
    label: "Apgar",
    options: [],
  },
  {
    name: "alimentacion",
    type: "select",
    label: "Alimentación de los primeros 6 meses",
    options: [
      { label: "Leche Materna", value: "Leche Materna" },
      { label: "Fórmula", value: "Fórmula" },
      { label: "Otros", value: "Otros" },
    ],
  },
  {
    name: "edadFijaMirada",
    type: "number",
    label: "¿A que edad fija la mirada?",
    options: [],
  },
  {
    name: "edadSostieneCabeza",
    type: "number",
    label: "¿A que edad sostiene la cabeza?",
    options: [],
  },
  {
    name: "edadSonrie",
    type: "number",
    label: "¿A que edad sonríe?",
    options: [],
  },
  {
    name: "edadGatea",
    type: "number",
    label: "¿A que edad gatea?",
    options: [],
  },
  {
    name: "edadHabla",
    type: "number",
    label: "¿A que edad habla?",
    options: [],
  },
  {
    name: "edadCamina",
    type: "number",
    label: "¿A que edad camina?",
    options: [],
  },
  {
    name: "rezago",
    type: "select",
    label: "Recuperación de Rezago",
    options: [
      { label: "Recuperado de riesgo de retraso", value: "Recuperado de riesgo de retraso" },
      { label: "En seguimiento", value: "En seguimiento" },
    ],
  }
];

export default function HealthyChildMex({
  setShowModalServer,
  setErrorServer,
  setShowSuccess,
  citaId,
  child = null,
  validationData,
}) {
  const { auth } = useContext(authContext);
  const [isSubmiting, setSubmiting] = useState(false);
  const [id, setId] = useState(null);
  const schema = Yup.object().shape({
    ninoSanoRT: Yup.number().test(
      'ninoSanoRT',
      'Valor inválido',
      function (value) {
        const { age, speciality } = validationData;
        if (age.years < 10 && ![15, 16].includes(speciality)) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    pesoParaTalla: Yup.number().test(
      'pesoParaTalla',
      'Valor inválido',
      function (value) {
        const { age, speciality } = validationData;
        if (age.years < 5 && ![15, 16].includes(speciality)) {
          return value >= 1 && value <= 5;
        } else {
          return value == -1;
        }
      }
    ),
    pruebaEDI: Yup.number().test(
      'pruebaEDI',
      'Valor inválido',
      function (value) {
        const { age } = validationData;
        if (age.years < 6) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    resultadoEDI: Yup.number().test(
      'resultadoEDI',
      'Valor inválido',
      function (value) {
        const { pruebaEDI } = this.parent;
        if (pruebaEDI == 0) {
          return value >= 1 && value <= 3;
        } else if (pruebaEDI == 1) {
          return value >= 4 && value <= 6;
        } else {
          return value == -1;
        }
      }
    ),
    resultadoBattelle: Yup.number().test(
      'resultadoBattelle',
      'Valor inválido',
      function (value) {
        const { age } = validationData;
        const totalMonths = age.years * 12 + age.months;
        if (totalMonths >= 16 && totalMonths < 60) {
          return value >= 1 && value <= 3;
        } else {
          return value == -1;
        }
      }
    ),
    aplicacionCedulaCancer: Yup.number().test(
      'aplicacionCedulaCancer',
      'Valor inválido',
      function (value) {
        const { age, speciality } = validationData;
        if (age.years < 18 && ![15, 16].includes(speciality)) {
          return value == 1 || value == 2;
        } else {
          return value == -1;
        }
      }
    ),
    confirmacionCancer: Yup.number().test(
      'confirmacionCancer',
      'Valor inválido',
      function (value) {
        const { clues, age, speciality } = validationData;
        if (/*DIRECTORIO_UMAS.includes(clues) &&*/ age.years < 18 && ![15, 16].includes(speciality)) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    edasRT: Yup.number().test(
      'edasRT',
      'Valor inválido',
      function (value) {
        const { age, speciality } = validationData;
        if (age.years < 5 && ![15, 16].includes(speciality)) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    edasPlanTratamiento: Yup.number().test(
      'edasPlanTratamiento',
      'Valor inválido',
      function (value) {
        const { edasRT } = this.parent;
        if (edasRT !== -1) {
          return value >= 1 && value <= 3;
        } else {
          return value == -1;
        }
      }
    ),
    recuperadoDeshidratacion: Yup.number().test(
      'recuperadoDeshidratacion',
      'Valor inválido',
      function (value) {
        const { edasRT } = this.parent;
        if (edasRT !== -1) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    numeroSobresVSOTratamiento: Yup.number().test(
      'numeroSobresVSOTratamiento',
      'Valor inválido',
      function (value) {
        const { edasRT } = this.parent;
        if (edasRT !== -1) {
          return value >= 0 && value <= 9;
        } else {
          return value == 0;
        }
      }
    ),
    numeroSobresVSOPromocion: Yup.number().test(
      'numeroSobresVSOPromocion',
      'Valor inválido',
      function (value) {
        const { speciality } = validationData;
        if (![15, 16].includes(speciality)) {
          return value >= 0 && value <= 9;
        } else {
          return value == 0;
        }
      }
    ),
    irasRT: Yup.number().test(
      'irasRT',
      'Valor inválido',
      function (value) {
        const { age, speciality } = validationData;
        if (age.years < 5 && ![15, 16].includes(speciality)) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    irasPlanTratamiento: Yup.number().test(
      'irasPlanTratamiento',
      'Valor inválido',
      function (value) {
        const { irasRT } = this.parent;
        if (irasRT !== -1) {
          return value == 1 || value == 2;
        } else {
          return value == -1;
        }
      }
    ),
    neumoniaRT: Yup.number().test(
      'neumoniaRT',
      'Valor inválido',
      function (value) {
        const { irasRT } = this.parent;
        if (irasRT !== -1) {
          return value == 0 || value == 1;
        } else {
          return value == -1;
        }
      }
    ),
    gesta: Yup.number().required('Campo requerido'),
    tipoNacimiento: Yup.string().oneOf(['Parto', 'Cesarea'], 'Selecciona una opción válida'),
    edadGestacional: Yup.number().required('Campo requerido'),
    persoAlNacer: Yup.number().required('Campo requerido'),
    apgar: Yup.number().required('Campo requerido'),
    alimentacion: Yup.string()
  .oneOf(['Leche Materna', 'Fórmula', 'Otros'], 'Selecciona una opción válida')
  .required('Requerido'),
    edadFijaMirada: Yup.number().required('Campo requerido'),
    edadSostieneCabeza: Yup.number().required('Campo requerido'),
    edadSonrie: Yup.number().required('Campo requerido'),
    edadGatea: Yup.number().required('Campo requerido'),
    edadHabla: Yup.number().required('Campo requerido'),
    edadCamina: Yup.number().required('Campo requerido'),
    rezago: Yup.string().oneOf(['Recuperado de riesgo de retraso', 'En seguimiento'], 'Selecciona una opción válida'),
  });
  const [initValues, setInitValues] = useState(child);
  useEffect(() => {
    if (initValues?.id) {
      setSubmiting(true);
      Get({
        url: `${MEDICAL_HISTORY_MX}/find-healthy-child/${initValues.id}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          setInitValues(response.data);
          setSubmiting(false);
        })
        .catch((error) => {
          console.log(error);
          setSubmiting(false);
        });
    }
  }, [initValues?.id, auth.data.access_token]);
  return (
    <>
      <Formik
        initialValues={initValues
          ? initValues
          : {
            appointmentId: citaId,
            ninoSanoRT: "-1",
            pesoParaTalla: "-1",
            pruebaEDI: "-1",
            resultadoEDI: "-1",
            resultadoBattelle: "-1",
            aplicacionCedulaCancer: "-1",
            confirmacionCancer: "-1",
            edasRT: "-1",
            edasPlanTratamiento: "-1",
            recuperadoDeshidratacion: "-1",
            numeroSobresVSOTratamiento: "0",
            numeroSobresVSOPromocion: "0",
            irasRT: "-1",
            irasPlanTratamiento: "-1",
            neumoniaRT: "-1",
            gesta: "",
            tipoNacimiento: "",
            edadGestacional: "",
            persoAlNacer: "",
            apgar: "",
            alimentacion: "",
            edadFijaMirada: "",
            edadSostieneCabeza: "",
            edadSonrie: "",
            edadGatea: "",
            edadHabla: "",
            edadCamina: "",
            rezago: "",
          }}
        validationSchema={schema}
        enableReinitialize
        onSubmit={async (values, { setSubmitting, setFieldValue }) => {
          setSubmiting(true);
          if (id) {
            const body = {
              id,
              ...values,
            };
            try {
              const response = await Put({
                url: `${MEDICAL_HISTORY_MX}/update-healthy-child/`,
                data: body,
                access_token: auth.data.access_token,
                header: true,
              });
              console.log(response);
              setSubmiting(false);
              setTimeout(() => {
                setShowSuccess(false);
              }, 2000);
            } catch (error) { }
          } else {
            try {
              const response = await Post({
                url: `${MEDICAL_HISTORY_MX}/save-healthy-child/`,
                data: values,
                access_token: auth.data.access_token,
                header: true,
              });
              console.log(response);
              setId(response.data.id);
              setSubmiting(false);
              setTimeout(() => {
                setShowSuccess(false);
              }, 2000);
            } catch (error) {
              setSubmiting(false);
              setShowModalServer(true);
              if (error.response) {
                setErrorServer(error.response);
              }
            }
          }
          console.log(values);
        }}
      >
        {({ values, errors, handleChange, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            {isSubmiting && <SimpleLoad />}
            <Row>
              <Col xs="12" md="6">
                <dl className="row">
                  {fields1.map((it) => (
                    <Fragment key={it.name}>
                      <dt className="col-sm-5">{it.label}</dt>
                      <dd className="col-sm-7">
                        <Controller
                          type={it.type}
                          name={it.name}
                          errors={errors}
                          onChange={handleChange}
                          options={it.options}
                        />
                      </dd>
                    </Fragment>
                  ))}
                </dl>
              </Col>
              <Col xs="12" md="6">
                <dl className="row">
                  {fields2.map((it) => (
                    <Fragment key={it.name}>
                      <dt className="col-sm-5">{it.label}</dt>
                      <dd className="col-sm-7">
                        <Controller
                          type={it.type}
                          name={it.name}
                          errors={errors}
                          onChange={handleChange}
                          options={it.options}
                        />
                      </dd>
                    </Fragment>
                  ))}
                </dl>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col className="text-right">
                <Button
                  variant="outline-success"
                  className="ok-buttom"
                  type="submit"
                >
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
}
